import React, { useState } from 'react';
import OfferLetterForm from './OfferLetterForm';
import OfferLetterTemplate from './OfferLetterTemplate';
import { generateAndUpload } from '../../utils/offerLetterUtils';
import { toast } from 'react-toastify';
import './offerLetter.css';

const OfferLetterModal = ({ advisor, onClose, show, setDone, done }) => {
  const [data, setData] = useState({
    name: advisor?.name || '',
    email: advisor?.email || '',
    phone: advisor?.mobile_number || '',
    address: advisor?.address || '',
    date: new Date().toISOString().split('T')[0],
    refNo: '',
    district: '',
    state: '',
    salaryDescription: '',
    joiningDate: new Date().toISOString().split('T')[0],
    website: 'www.bandhanguru.com',
    fatherName: '',
    alternatePhone: ''
  });

  const [activeTab, setActiveTab] = useState('form');
  const [isGenerating, setIsGenerating] = useState(false);

  const getPositionType = () => {
    const advisorRole = advisor?.roles?.find(role =>
      ['advisor-district-coordinator', 'advisor-commisionerate', 'advisor-state-head'].includes(role.userType)
    );

    if (advisorRole?.userType === 'advisor-district-coordinator') return 'District Coordinator';
    if (advisorRole?.userType === 'advisor-commisionerate') return 'Commissioner Manager';
    if (advisorRole?.userType === 'advisor-state-head') return 'State Head';
    return 'District Coordinator';
  };

  const handleGenerate = async () => {
    try {
      setIsGenerating(true);
      await generateAndUpload(data, advisor, getPositionType());
      toast.success('Offer letter generated and uploaded successfully!')
      onClose();
    } catch (error) {
      console.error('Error generating offer letter:', error);
      toast.error(error?.response?.data?.message || error.message || 'Failed to generate offer letter');
    } finally {
      setTimeout(() => {
        setDone(prev => !prev);
      }, 2000);
      setIsGenerating(false);
    }
  };

  if (!show) return null;

  return (
    <div className="offer-modal-overlay">
      <div className="offer-modal">
        <div className="offer-modal-header">
          <h2>Generate Offer Letter - {getPositionType()}</h2>
          <button className="offer-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="offer-modal-tabs">
          <button
            className={`offer-tab-btn ${activeTab === 'form' ? 'active' : ''}`}
            onClick={() => setActiveTab('form')}
          >
            Edit Details
          </button>
          <button
            className={`offer-tab-btn ${activeTab === 'preview' ? 'active' : ''}`}
            onClick={() => setActiveTab('preview')}
          >
            Preview
          </button>
        </div>

        <div className="offer-modal-content">
          {activeTab === 'form' ? (
            <OfferLetterForm
              data={data}
              setData={setData}
              positionType={getPositionType()}
            />
          ) : (
            <div className="offer-preview-section">
              <OfferLetterTemplate
                data={data}
                positionType={getPositionType()}
              />
            </div>
          )}
        </div>

        <div className="offer-modal-actions">
          <button className="offer-btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="offer-btn-primary"
            onClick={handleGenerate}
            disabled={activeTab === 'form' || isGenerating}
          >
            {isGenerating ? 'Generating...' : 'Generate & Upload PDF'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferLetterModal;